import { apiUrl } from '../../../config/api';
export async function fetchPlayoffsData() {
    const response = await fetch(apiUrl('seriesPlayoffs'));

    if (!response.ok) {
        throw new Error(`Error al cargar series de playoffs (${response.status})`);
    }

    const payload = await response.json();

    if (typeof payload === 'string') {
        return JSON.parse(payload);
    }

    return payload;
}
